import React from "react";
import styles from "./styles.module.css";
import RightArrow from "../../images/RightArrow";

const CTAButton = ({ className = "", titleClass, subtitleClass, iconClass, arrowClass }) => {
    function handleCTA() {
        if (window.fbq)
            window.fbq('trackCustom', 'ShopeeClick');
        const url = 'https://shopee.sg/OTUS-Vision-Trainer%EF%BF%BD%EF%BF%BD-Smart-Automated-Eye-Exercise-Device-Free-OTUS-Smartphone-Holder-(Limited-Event)-i.691836088.25296891984?sp_atk=6d22c20b-eebd-48cd-9cf4-f98e27e81bfb&xptdk=6d22c20b-eebd-48cd-9cf4-f98e27e81bfb'
        window.open(url, '_blank')
    }

    const isMobile = window.innerWidth <= 1140

    return (
        <button className={`${styles.cta_button} ${className}`} onClick={handleCTA}>
            <div>
                <img src={require('./shopee_icon.png')} className={!iconClass ? styles.shopee : iconClass} />
                <div style={{ gap: 0 }}>
                    <span className={titleClass} style={{ color: '#fff' }}>
                        Buy on Shopee
                    </span>
                    <span className={subtitleClass} style={{ color: "#FFBAA1", fontSize: isMobile ? "12px" : "18px", fontWeight: 400, marginTop: isMobile ? "0px" : "12px" }}>Free Shipping on Shopee</span>
                </div>
                <img src={require('./arrow.png')} className={!arrowClass ? styles.arrow : arrowClass} />
            </div>
        </button>
    )
}

export default CTAButton